import React from 'react';
import theme from '../theme';

const NotificationsPage = () => {
  return (
    <div style={{ padding: '40px' }}>
      <h1 style={{ fontSize: '32px', fontWeight: 700, color: theme.colors.text.primary, fontFamily: theme.fonts.heading, marginBottom: '16px' }}>
        Notifications
      </h1>
      <p style={{ fontSize: '16px', color: theme.colors.text.secondary }}>View all your notifications</p>
    </div>
  );
};

export default NotificationsPage;
